import * as React from 'react';

import { useAtom, WritableAtom } from 'jotai';

export const useDebouncedAtom = <T, Args extends unknown[], Result>(
  atom: WritableAtom<T, Args, Result>,
  delay: number,
) => {
  const [atomValue, setAtomValue] = useAtom(atom);
  const [innerValue, setInnerValue] = React.useState(atomValue);

  const updateTimeout = React.useRef<NodeJS.Timeout | null>(null);

  const setValue = React.useCallback(
    (...args: Args) => {
      setInnerValue(args[0] as Awaited<T>);

      if (updateTimeout.current) {
        clearTimeout(updateTimeout.current);
      }

      updateTimeout.current = setTimeout(() => {
        setAtomValue(...args);
      }, delay);
    },
    [delay, setAtomValue],
  );

  return [innerValue, setValue] as const;
};
